import { toast } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { constants } from 'modules/common';
import { useCallback, useEffect } from 'react';
import { routingService } from 'services/routing';
import { useCompleteSlackInstall } from 'shared/data/slack/v1';
import { getDefaultPath } from 'urlBuilder';

export const useSlackAuthInstallPageData = () => {
    const [code] = hooks.useQueryParam('code');
    const [state] = hooks.useQueryParam('state');
    const [error] = hooks.useQueryParam('error');
    const [errorDescription] = hooks.useQueryParam('error_description');

    const { mutate, data, isLoading } = useCompleteSlackInstall({
        onSuccess: (data) => {
            if (data.appDeepLink) {
                window.location.href = data.appDeepLink;
            }
        },
    });

    const onOpenSlack = useCallback(() => {
        if (data?.appDeepLink) {
            window.location.href = data.appDeepLink;
        }
    }, [data?.appDeepLink]);

    const onAuthWithoutConnect = useCallback(() => {
        mutate({ body: { code, state } });
    }, [mutate, code, state]);

    useEffect(() => {
        if (error) {
            if (error === 'access_denied') {
                window.location.href = constants.commonConstants.SLACK_APP_URL;
            } else {
                toast.error(errorDescription);

                routingService.push(getDefaultPath());
            }
        } else {
            onAuthWithoutConnect();
        }
    }, [onAuthWithoutConnect, error, errorDescription]);

    return {
        isLoading,
        appDeepLink: data?.appDeepLink,
        onOpenSlack,
    };
};
